import { Form } from "react-router-dom";
import { Button, ButtonGroup } from "@vds/buttons";
import React, { useState, useEffect, useRef } from "react";
import {
  addTagToDeviceApi,
  addTagToDeviceEndPoint,
  createNewandGetTagEndPoint,
  deleteTagEndPoint,
  setDeviceNameEndPoint,
} from "../../../configuration";
import { getRandomUUID } from "../../../Token";
import { DropdownSelect } from "@vds/selects";
import { Input } from "@vds/inputs";
import { Tab, Tabs } from "@vds/tabs";
import { Chip } from "@mui/material";
import { useSelector } from "react-redux";
import axiosInstance from "../../axiosInterceptor";

const EditDevice = React.forwardRef((props, ref) => {
  let deviceInfo = props?.deviceInfo;
  const storeTagList = useSelector((state) => state.reportReducer.tagData);
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const [deviceName, setDeviceName] = useState(deviceInfo.name);
  const [channelInfo, setChannelInfo] = useState(props.channelInfo);
  const [error, setError] = useState("");
  const [tagToggle, setTagToggle] = useState("");
  const [typeOfTag, setTypeOfTag] = useState("");
  const [tag, setTag] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [tagsList, setTagsList] = useState([]);
  const [deleteTag, setDeleteTag] = useState([]);
  const [newTag, setNewTag] = useState("");
  const [errors, setErrors] = useState({
    tagName: "",
  });
  const [location, setLocation] = useState(
    deviceInfo.customdata ? deviceInfo.customdata.location : ""
  );
  const [description, setDescription] = useState(
    deviceInfo.customdata ? deviceInfo.customdata.description : ""
  );
  const [relativeTopPosition, setRelativeTopPosition] = useState(
    deviceInfo.customdata
      ? deviceInfo.customdata.cameralocation
        ? deviceInfo.customdata.cameralocation.top
        : ""
      : ""
  );
  const [relativeLeftPosition, setRelativeLeftPosition] = useState(
    deviceInfo.customdata
      ? deviceInfo.customdata.cameralocation
        ? deviceInfo.customdata.cameralocation.left
        : ""
      : ""
  );

  const tagNameRef = useRef(null);

  const onApply = async () => {
    const response = await axiosInstance.patch(setDeviceNameEndPoint(), {
        accountname: activeSession.accountId,
        resourceidentifier: { deviceid: deviceInfo.uid },
        device: {
          name: deviceName,
          customdata: {
            location: location,
            cameralocation: {
              top: relativeTopPosition,
              left: relativeLeftPosition,
            },
          },
        },
    });
    if (response.status === 200) {
      console.log("Name changed successfully");
      props.setShowEditDevice(false, deviceName, location);
    } else {
      console.log("Name change failed");
      setError("Name change failed");
    }
  };
  const applyForStream = async () => {
    const response = await axiosInstance.patch(setDeviceNameEndPoint(), {
        accountname: activeSession.accountId,
        resourceidentifier: { deviceid: deviceInfo.uid },
        device: {
          name: channelInfo.name,
          customdata: {
            description: description,
          },
        },
    });
    if (response.status === 200) {
      console.log("Name changed successfully");
      props.setShowEditDevice(false, deviceName, location);
    } else {
      console.log("Name change failed");
      setError("Name change failed");
    }
  };
  const addTagDevice = async (tagIds) => {
    try {
      let resourceidentifier = {};
      let refidType = deviceInfo?.refidtype;
      let id = deviceInfo?.refid;
      if (refidType === "uuid") {
        refidType = "deviceId";
        id = deviceInfo?.id;
      }
      resourceidentifier[refidType] = id;

      const response = await axiosInstance.patch(addTagToDeviceEndPoint(), {
          accountname: activeSession.accountId,
          resourceidentifier: resourceidentifier,
          device: {
            tagids: tagIds,
          },
      });
      const res = response.data;
      // props.setDeviceTagsList([res])
      if (res) {
        console.log("Tag added to device");
        props.setShowEditDevice(false, deviceName, location);
      } else {
        console.log("failed to add tag to device");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const createTag = async () => {
    try {
      if (tag !== "") {
        const response = await axiosInstance.post(
          createNewandGetTagEndPoint(),
          {
              accountname: activeSession.accountId,
              tags: [
                {
                  name: tag,
                  // kind: "ts.tag.gateway.vision.companion",
                  kind:
                    typeOfTag === ""
                      ? "ts.tag.gateway.vision.companion"
                      : typeOfTag,
                },
              ],
          }
        );
        const res = response.data;
        if (res && res?.length > 0) {
          const oldArray = [...props.deviceTagsList];
          oldArray.push(res[0]);
          addTagDevice(oldArray.map((a) => a.id));
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  // useEffect(() => {
  //   if (activeTab === 1) {
  //     getTags();
  //   }
  // }, [activeTab]);
  const onExit = () => {
    props.setShowEditDevice(false, "");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const handleDelete = async (tagId) => {
    try {
      const response = await axiosInstance.delete(deleteTagEndPoint(), {
          accountname: activeSession.accountId,
          resourceidentifier: {
            id: tagId,
          },
      });
      const res = response.data;
      if (res) {
        console.log("Tag added to device");
        props.setShowEditDevice(false, deviceName, location);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleCreateEditTag = async () => {
    try {
      if (deleteTag?.length) {
        const newArr = props.deviceTagsList.flatMap((i) => i.id);
        // const newArr = props.deviceTagsList.filter(item => !deleteTag.includes(item));
        // if (newArr.length > 0) {
        addTagDevice(newArr);
        // }

        // await Promise.all(
        //   deleteTag?.map(async (item) => {
        //     await handleDelete(item);
        //   })
        // );
      }
      if (tagToggle === "newTag") {
        if (tag !== "") {
          createTag();
        }
      } else if (tagToggle) {
        const oldArray = [...props.deviceTagsList];
        const notExists = oldArray.find((t) => t.id === tagToggle);
        if (notExists === undefined) {
          const addedTag = tagsList.find((t) => t.id === tagToggle);
          if (addedTag) {
            oldArray.push(addedTag);
            const arrayUniqueByKey = [
              ...new Map(oldArray.map((item) => [item["id"], item])).values(),
            ];
            props.setDeviceTagsList(arrayUniqueByKey);

            addTagDevice(arrayUniqueByKey.map((a) => a.id));
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleChange = (event) => {
    console.log("handle", event);
    setChannelInfo((oldVal) => {
      return { ...oldVal, name: event.target.value };
    });
    setDescription(description);
  };

  console.log("channelInfo", channelInfo);
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 5,
      }}
    >
      <Tabs
        orientation="horizontal"
        indicatorPosition="bottom"
        fillContainer={false}
      >
        <Tab
          label="Device Details"
          // selected={activeTab.compains}
          selected={activeTab === 0}
          onClick={() => {
            setActiveTab(0);
          }}
        />
        <Tab
          label="Tags"
          // selected={activeTab.compains}
          selected={activeTab === 1}
          onClick={() => {
            setActiveTab(1);
          }}
        />
      </Tabs>
      {activeTab === 0 && (
        <Form
          style={{ marginLeft: 0, marginRight: 50, marginBottom: 20 }}
          onSubmit={handleSubmit}
        >
          {channelInfo !== undefined && channelInfo?.name !== "" ? (
            <>
              <Input
                type="text"
                label="Choose Name"
                value={channelInfo?.name}
                onChange={handleChange}
              />
              <Input
                type="text"
                label="Enter Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <ButtonGroup
                className="btn"
                childWidth={"100%"}
                viewport={"desktop"}
                marginTop="10px"
                rowQuantity={{ desktop: 2 }}
                data={[
                  {
                    children: "Exit",
                    size: "large",
                    use: "secondary",
                    width: "125px",
                    onClick: onExit,
                  },
                  {
                    children: "Apply",
                    size: "large",
                    use: "primary",
                    width: "125px",
                    onClick: applyForStream,
                  },
                ]}
                alignment={"left"}
              />
            </>
          ) : (
            <>
              <label>Choose a device name</label>
              <br />
              <input
                type="text"
                placeholder=""
                value={deviceName}
                onChange={(e) => setDeviceName(e.target.value)}
              />
              <br />
              <label>Device Location</label>
              <br />
              <input
                type="text"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              />
              <br />
              <label>Camera Relative Position</label>
              <br />
              <label>From Top</label>
              <input
                type="text"
                value={relativeTopPosition}
                onChange={(e) => setRelativeTopPosition(e.target.value)}
              />
              <br />
              <label>From Left</label>
              <input
                type="text"
                value={relativeLeftPosition}
                onChange={(e) => setRelativeLeftPosition(e.target.value)}
              />
              <br />
              <label>Firmware</label>
              <br />
              <input type="text" disabled value={deviceInfo.firmwareVersion} />
              <br />
              <label>IMEI Number</label>
              <br />
              <input type="text" disabled value={deviceInfo.imei} />
              <br />
              <label>Cellular Data</label>
              <br />
              <input type="text" disabled value="Verizon" />
              <br />
              <br />
              <input type="text" disabled value={deviceInfo.code} />
              <br />
              <br />

              <ButtonGroup
                childWidth={"100%"}
                viewport={"desktop"}
                rowQuantity={{ desktop: 2 }}
                data={[
                  {
                    children: "Exit",
                    size: "large",
                    use: "secondary",
                    width: "125px",
                    onClick: onExit,
                  },
                  {
                    children: "Apply",
                    size: "large",
                    use: "primary",
                    width: "125px",
                    onClick: onApply,
                  },
                ]}
                alignment={"left"}
              />
            </>
          )}
          <p
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "red",
            }}
          >
            {error}
          </p>
        </Form>
      )}

      {activeTab === 1 && (
        <div>
          <label className="mt-3" style={{ fontSize: "12px" }}>
            Availble Tags
          </label>
          <div
            className="mt-2 mb-2"
            style={{
              border: "1px solid",
              overflowY: "auto",
              padding: "5px",
              minHeight: "150px",
            }}
          >
            {props.deviceTagsList?.length > 0 &&
              props.deviceTagsList?.map((itm, index) => (
                <span style={{ margin: "5px" }}>
                  <Chip
                    onDelete={() => {
                      setDeleteTag((prev) => [...prev, itm.id]);
                      const list = [...props.deviceTagsList];
                      list.splice(index, 1);
                      props.setDeviceTagsList(list);
                    }}
                    label={itm?.name || ""}
                  />
                </span>
              ))}
          </div>

          {/* <div className="d-flex mt-4 2">
          <div>
            <input type="radio" id="editTag" name='tag' value='edit' onChange={(e)=>{setTagToggle(e.target.value)}} checked={tagToggle==='edit'} />
            <label for="editTag">Edit Tag</label><br/>
          </div>
        <div className='pl-3' style={{marginLeft:'15px'}}>
            <input type="radio" id="newTag" name='tag' value='new' onChange={(e)=>{setTagToggle(e.target.value)}} checked={tagToggle==='new'} />
            <label for="newTag">Create Tag</label><br/>
        </div>
        </div> */}

          <DropdownSelect
            label="Tag"
            errorText="Select a Tag"
            error={false}
            disabled={false}
            readOnly={false}
            onChange={(e) => {
              setTagToggle(e.target.value);
            }}
          >
            <option> </option>
            {Array.isArray(tagsList) &&
              tagsList?.map((item) => (
                <option value={item?.id}>{item?.name}</option>
              ))}
            <option value="newTag">Create Tag</option>
          </DropdownSelect>
          {tagToggle === "newTag" && (
            <div>
              <Input
                label="Tag Name"
                className="mt-2"
                ref={tagNameRef}
                autoFocus={true}
                // required="true"
                value={tag || ""}
                onChange={(e) => {
                  setTag(e.target.value);
                }}
              />
              {/* {errors.tagName && <span className="error"></span>} */}
              <DropdownSelect
                label="Type of Tag"
                errorText="Select a Tag"
                error={false}
                onChange={(e) => {
                  setTypeOfTag(e.target.value);
                }}
              >
                <option></option>
                {tagsList?.length > 0 &&
                  [
                    ...new Map(
                      tagsList.map((item) => [item["kind"], item])
                    ).values(),
                  ]?.map((item) => (
                    <option value={item?.kind}>{item?.kind}</option>
                  ))}
              </DropdownSelect>
            </div>
          )}

          <div className="mt-3 d-flex justify-content-end">
            <Button onClick={handleCreateEditTag}>Update</Button>
          </div>
        </div>
      )}
    </div>
  );
});

export default EditDevice;
